export default __webpack_public_path__ + "static/media/icon-upload-primary.6395465c.svg";